import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8e3c15ee")

_pushScopeId("data-v-8e3c15ee")
const _hoisted_1 = { class: "service-info-container" }
const _hoisted_2 = { class: "content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_qr_code = _resolveComponent("qr-code")
  const _component_van_tab = _resolveComponent("van-tab")
  const _component_info = _resolveComponent("info")
  const _component_van_tabs = _resolveComponent("van-tabs")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_van_tabs, {
        active: _ctx.active,
        "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => (_ctx.active = $event)),
        swipeable: "",
        sticky: "",
        color: "#FF931F",
        background: "#f4f4f4",
        "line-width": "0.36rem"
      }, {
        default: _withId(() => [
          _createVNode(_component_van_tab, {
            name: "qrCode",
            title: "二维码"
          }, {
            default: _withId(() => [
              _createVNode(_component_qr_code)
            ]),
            _: 1
          }),
          _createVNode(_component_van_tab, {
            name: "info",
            title: "数据"
          }, {
            default: _withId(() => [
              _createVNode(_component_info)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["active"])
    ]),
    _createVNode("div", {
      class: "logout-btn",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
    }, "退出")
  ]))
})